module.exports = {
  prefix: '',
  important: false,
  separator: ':',
  theme: {
    screens: {
      sm: '576px',
      md: '768px',
      'card-container-md': '818px',
      'card-md': '576px',
      lg: '882px',
      'card-container-lg': '932px',
      'card-lg': '864px',
      xl: '1170px',
      'card-container-xl': '1220px',
      'card-xl': '1152px'
    },
    colors: {
      'transparent': 'transparent',
      'white': '#ffffff',
      'smoke-white': '#F6F7F9',
      'granite-gray': '#666666',
      'columbia-gray': '#D1D8DF',
      'jet-black': '#333333',
      'danaher-blue': '#326195',
      'columbia-blue': '#D1D8DF',
      'piction-blue': '#3BC7E5',
      'imperial-blue': '#035D67',
      'tufts-blue': '#48A1E5',
      'tufts-blue-text': '#3D88C2',
      'tufts-blue-small': '#306B99',
      'gator-orange': '#FF6F19',
      'gator-orange-text': '#D65D15',
      'gator-orange-small': '#DC6016',
      'asparagus-green': '#A2A568',
      'asparagus-green-text': '#828554',
      'asparagus-green-small': '#676942',
      'goldenrod-yellow': '#D89B2B',
      'goldenrod-yellow-text': '#A87922',
      'goldenrod-yellow-small': '#855F1A'
    },
    spacing: {
      px: '1px',
      '0': '0',
      '5': '.5rem',
      '10': '1rem',
      '15': '1.5rem',
      '16': '1.6rem',
      '20': '2rem',
      '25': '2.5rem',
      '30': '3rem',
      '32': '3.2rem',
      '35': '3.5rem',
      '40': '4rem',
      '45': '4.5rem',
      '48': '4.8rem',
      '50': '5rem',
      '55': '5.5rem',
      '60': '6rem',
      '65': '6.5rem',
      '75': '7.5rem',
      '90': '9rem',
      '100': '10rem',
      '135': '13.5rem',
      '150': '15rem',
      '170': '17rem',
      '200': '20rem',
      'full': '100%',
      'screen': '100vh'
    },
    backgroundColor: theme => theme('colors'),
    backgroundPosition: {
      'center': 'center'
    },
    backgroundSize: {
      'auto': 'auto',
      'cover': 'cover',
      'contain': 'contain'
    },
    borderColor: theme => ({
      ...theme('colors'),
      default: theme('colors["granite-gray"]', 'currentColor'),
    }),
    borderRadius: {
      none: '0',
      default: '.8rem',
      wide: '1rem',
      circle: '50%',
      full: '999rem'
    },
    borderWidth: {
      default: '1px',
      '0': '0',
      '2': '2px',
      '4': '4px',
      '6': '6px',
      '8': '8px',
      '16': '16px'
    },
    boxShadow: theme => ({
      inner: `inset 0px 0px 0px 1px ${theme('colors["piction-blue"]')}`,
      outer: '0px 4px 4px rgba(0, 0, 0, 0.25)'
    }),
    container: {
      center: true,
    },
    cursor: {
      pointer: 'pointer',
    },
    fill: theme => ({
      ...theme('colors'),
      'none': 'none',
    }),
    flex: {
      '1': '1 1 0%',
      auto: '1 1 auto',
      initial: '0 1 auto',
      none: 'none'
    },
    flexGrow: {
      '0': '0',
      default: '1'
    },
    flexShrink: {
      '0': '0',
      default: '1'
    },
    fontFamily: {
      sans: [
        'Lato',
        'Helvetica Neue',
        'Arial',
        'sans-serif'
      ],
      serif: [
        'Playfair Display',
        'Georgia',
        'serif'
      ],
      condensed: [
        'Barlow Condensed',
        'Helvetica Neue',
        'Arial',
        'sans-serif'
      ]
    },
    fontSize: {
      '9': '.9rem',
      '10': '1rem',
      '12': '1.2rem',
      '13': '1.3rem',
      '14': '1.4rem',
      '16': '1.6rem',
      '18': '1.8rem',
      '20': '2rem',
      '22': '2.2rem',
      '24': '2.4rem',
      '30': '3rem',
      '36': '3.6rem',
      '48': '4.8rem',
      '64': '6.4rem',
      '76': '7.6rem',
      '96': '9.6rem',
      '128': '12.8rem'
    },
    fontWeight: {
      normal: 400,
      bold: 700
    },
    height: theme => ({
      auto: 'auto',
      ...theme('spacing'),
      '52': '52px',
      '320': '320px',
      '344': '344px',
      'screen': '100vh',
      'full': '100%'
    }),
    inset: {
      '-13': '-13px',
      '0': '0',
      '3': '3px',
      '7': '7px',
      '10': '10px',
      '20': '20px',
      '25': '25px',
      '36': '36px',
      '45': '45px',
      '50': '50px',
      '57': '57px',
      'half': '50%',
      auto: 'auto'
    },
    letterSpacing: {
      tight: '-0.01em',
      normal: '0',
      wide: '0.02em'
    },
    lineHeight: {
      quarter: 0.25,
      sixth: 0.6,
      eighth: 0.8,
      ninth: 0.9,
      none: 1,
      tight: 1.1,
      normal: 1.5,
      spacey: 1.8,
      loose: 2
    },
    listStyleType: {
      none: 'none',
      disc: 'disc',
      decimal: 'decimal'
    },
    margin: (theme, { negative }) => ({
      auto: 'auto',
      '-100': '-100px',
      '-66': '-66px',
      '-61': '-61px',
      '-15': '-15px',
      '1/3': '33.33333%',
      '1/100': '1.2%',
      '57': '5.7rem',
      '115': '11.5rem',
      ...theme('spacing'),
      ...negative(theme('spacing'))
    }),
    maxHeight: {
      '0': '0',
      '3': '.3rem',
      '50': '5rem',
      '320': '32rem',
      '120': '12rem',
      '700': '70rem',
      '800': '80rem',
      '1050': '105rem',
      screen: '100vh'
    },
    maxWidth: theme => ({
      ...theme('screens'),
      none: 'initial',
      '0': '0',
      '120': '12rem',
      '150': '15rem',
      '256': '25.6rem',
      '320': '32rem',
      '372': '37.2rem',
      '545': '54.5rem',
      '736': '73.6rem',
      '2/3': '66%',
      full: '100%'
    }),
    minHeight: {
      '0': '0',
      '117': '11.7rem',
      '320': '32rem',
      '625': '62.5rem',
      '667': '66.7rem',
      '720': '72rem',
      full: '100%',
      screen: '100vh'
    },
    minWidth: {
      '0': '0',
      '60': '6rem',
      '300': '30rem',
      '350': '35rem',
      full: '100%'
    },
    objectPosition: {
      bottom: 'bottom',
      center: 'center',
      left: 'left',
      'left-bottom': 'left bottom',
      'left-top': 'left top',
      right: 'right',
      'right-bottom': 'right bottom',
      'right-top': 'right top',
      top: 'top'
    },
    opacity: {
      '0': '0',
      '25': '.25',
      '50': '.5',
      '75': '.75',
      '85': '.85',
      '90': '.9',
      '100': '1'
    },
    order: {
      first: '-9999',
      last: '9999',
      none: '0',
      '1': '1',
      '2': '2',
      '3': '3',
      '4': '4',
      '5': '5',
      '6': '6',
      '7': '7',
      '8': '8',
      '9': '9',
      '10': '10',
      '11': '11',
      '12': '12'
    },
    padding: theme => ({
      ...theme('spacing'),
      '115': '115px',
      '128': '128px',
      '160': '160px'
    }),
    placeholderColor: theme => theme('colors'),
    stroke: theme => ({
      current: 'currentColor',
      white: theme('colors.white'),
      'granite-gray': theme('colors["granite-gray"]')
    }),
    textColor: theme => theme('colors'),
    width: theme => ({
      auto: 'auto',
      ...theme('screens'),
      ...theme('spacing'),
      '178': '178px',
      '256': '256px',
      '305': '305px',
      '344': '344px',
      '1/4': '25%',
      '1/3': '33.33333%',
      '1/2': '50%',
      '2/3': '66.66667%'
    }),
    zIndex: {
      auto: 'auto',
      '0': 0,
      '-1': '-1',
      '1': 1,
      '5': 5,
      '10': 10,
      '20': 20,
      '30': 30,
      '40': 40,
      '50': 50,
      '60': 60,
      '70': 70,
      'top': 100
    },
    translate: {
      '-1': '-1px',
      '-3': '-3px',
      '-5': '-5px',
      '1/2': '-50%',
      'full': '100%'
    },
    scale: {
      '0': '0',
      '100': '1',
      '110': '1.1',
      '130': '1.3',
      '150': '1.5'
    },
    rotate: {
      '-45': '-45deg',
      '45': '45deg',
      '225': '225deg',
      '315': '315deg',
      '405': '405deg',
      '495': '495deg',
    },
    transformOrigin: {
      't': '50% 0%',
      'r': '100% 50%',
      'b': '50% 100%',
      'l': '0% 50%'
    }
  },
  variants: {
    accessibility: ['responsive', 'focus'],
    alignContent: ['responsive'],
    alignItems: ['responsive'],
    alignSelf: ['responsive'],
    appearance: ['responsive'],
    backgroundColor: ['responsive', 'hover', 'focus'],
    backgroundPosition: [],
    backgroundSize: [],
    borderColor: ['responsive', 'hover', 'focus'],
    borderRadius: [],
    borderStyle: [],
    borderWidth: ['responsive'],
    boxShadow: ['hover', 'group-hover'],
    cursor: [],
    display: ['responsive'],
    fill: ['hover'],
    flex: ['responsive'],
    flexDirection: ['responsive'],
    flexGrow: ['responsive'],
    flexShrink: ['responsive'],
    flexWrap: ['responsive'],
    fontFamily: ['responsive'],
    fontSize: ['responsive'],
    fontSmoothing: [],
    fontStyle: ['responsive', 'hover', 'group-hover', 'focus'],
    fontWeight: ['responsive', 'hover', 'focus'],
    height: ['responsive'],
    inset: ['responsive'],
    justifyContent: ['responsive'],
    letterSpacing: ['responsive'],
    lineHeight: ['responsive'],
    listStylePosition: ['responsive'],
    listStyleType: ['responsive'],
    margin: ['responsive'],
    maxHeight: ['responsive'],
    maxWidth: ['responsive'],
    minHeight: ['responsive'],
    minWidth: ['responsive'],
    objectFit: ['responsive'],
    objectPosition: ['responsive'],
    opacity: ['hover', 'group-hover'],
    order: ['responsive'],
    overflow: ['responsive'],
    padding: ['responsive'],
    pointerEvents: [],
    position: ['responsive'],
    rotate: ['hover', 'group-hover'],
    scale: ['hover', 'group-hover'],
    stroke: ['group-hover'],
    textAlign: ['responsive'],
    textColor: ['responsive', 'hover', 'focus'],
    textDecoration: ['responsive', 'hover', 'group-hover', 'focus'],
    textTransform: ['responsive', 'hover', 'group-hover', 'focus'],
    transformOrigin: ['hover', 'group-hover'],
    translate: ['hover', 'group-hover'],
    verticalAlign: [],
    visibility: ['responsive'],
    whitespace: ['responsive'],
    width: ['responsive'],
    zIndex: []
  },
  corePlugins: {
    backgroundAttachment: false,
    backgroundRepeat: false,
    borderCollapse: false,
    float: false,
    outline: false,
    placeholderColor: false,
    resize: false,
    tableLayout: false,
    userSelect: false,
    wordBreak: false
  },
  plugins: [
    require('./plugins/transition')({
      transitions: {
        vslow: 'all 0.5s ease',
        slow: 'all 0.4s ease',
        normal: 'all 0.3s ease',
        fast: 'all 0.2s ease',
        vfast: 'all 0.1s ease'
      },
      variants: []
    }),
    require('./plugins/transform')()
  ]
}
